import { DefaultTheme } from "styled-components";

export const theme: { light: DefaultTheme; dark: DefaultTheme } = {
  light: {
    __key: "light",
    background: "#fff",
    backgroundSecondary: "#F5F5F5",
    foreground: "#22180C",
    primary: "#F29122",
    washLight: "#EBEBEB",
    washRegular: "#9F9F9F",
    washMedium: "#7B7B7B",
    washStrong: "#3A3A3A",
    error: "#ff5733",
  },
  dark: {
    __key: "dark",
    background: "#1E1E1E",
    backgroundSecondary: "#050505",
    foreground: "#fff",
    primary: "#F29122",
    washStrong: "#EBEBEB",
    washMedium: "#9F9F9F",
    washRegular: "#7B7B7B",
    washLight: "#3A3A3A",
    error: "#ff5733",
  },
};
